<template>
  <v-layout>
    <v-flex>
      <v-autocomplete
        v-model="levels"
        :items="saleLevels"
        chips
        small-chips
        deletable-chips
        clear-icon="mdi-close"
        clearable
        return-object
        @change="onLevelChanged"
        label="Trạng Thái"
        placeholder="Lọc theo trạng thái"
        multiple
        dense
        outlined
      ></v-autocomplete>
    </v-flex>
    <v-flex>
      <v-autocomplete
        v-model="assignees"
        :items="staffs"
        item-text="name"
        item-value="id"
        deletable-chips
        clear-icon="mdi-close"
        clearable
        chips
        small-chips
        @change="onLevelChanged"
        label="Nhân Viên Bán Hàng"
        placeholder="Lọc theo nhân viên bán hàng"
        multiple
        dense
        outlined
      ></v-autocomplete>
    </v-flex>
    <v-flex>
      <v-autocomplete
        v-model="onboard"
        :items="dates"
        item-text="name"
        return-object
        item-value="id"
        deletable-chips
        clear-icon="mdi-close"
        chips
        small-chips
        @change="onLevelChanged"
        label="Ngày Đăng Ký"
        placeholder="Lọc theo Ngày Đăng Ký"
        dense
        outlined
      ></v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data: () => ({
    query: '',
    saleLevels: [
      { value: 'L1A', text: 'L1A - Đúng số điện thoại' },
      { value: 'L1B', text: 'L1B - Chưa nghe máy' },
      { value: 'L1C', text: 'L1C - Sai số điện thoại' },
      { value: 'L2A', text: 'L2A - Đúng đối tượng - cần chăm sóc lại' },
      { value: 'L2C', text: 'L2C - Sai đối tượng' },
      { value: 'L3A', text: 'L3A - Có nhu cầu đã trao đổi' },
      { value: 'L3B', text: 'L3B - Cần chăm sóc lại' },
      { value: 'L3C', text: 'L3C - Chưa có nhu cầu' },
      { value: 'L7A', text: 'L7A - Đồng ý đến học trải nghiệm' },
      { value: 'L7B', text: 'L7B - Không đến học trải nghiệm' },
      { value: 'L7C', text: 'L7C - Đã học Trải nghiệm - Cần chốt sale' },
      { value: 'L7D', text: 'L7D - Đã học trải nghiệm - Không muốn học' },
      { value: 'L8A', text: 'L8A - Đã xác nhận học' },
      { value: 'L8B', text: 'L8B - Đã thanh toán' },
      { value: 'L8B2', text: 'L8B2 - Đã thanh toán 1 phần' },
      { value: 'L8C', text: 'L8C - Đúng số điện thoại' },
      { value: 'L8C', text: 'L8C - Đã huỷ' }
    ],
    assignees: [],
    levels: [],
    onboard: {},
    dates: [
      {
        name: 'Hôm Nay',
        time: moment()
          .startOf('date')
          .toISOString()
      },
      {
        name: 'Tuần Này',
        time: moment()
          .startOf('week')
          .toISOString()
      },
      {
        name: 'Tháng Này',
        time: moment()
          .startOf('month')
          .toISOString()
      }
    ]
  }),
  computed: {
    ...mapGetters('app', ['staffs'])
  },
  created: function () {
    this.onLevelChanged()
  },
  methods: {
    ...mapActions('contact', ['updateContact']),
    onLevelChanged () {
      this.query =
        this.levels
          .map(item => {
            return 'level_in=' + item.value
          })
          .join('&') +
        '&' +
        this.assignees
          .map(item => {
            return 'assignee_in=' + item
          })
          .join('&') +
        (this.onboard.time ? '&onboard_gte=' + this.onboard.time : '')
      this.$emit('onFilterChanged', this.query.replace('&&&', '&'))
    },
    onAssigneeChanged () {
      this.query +=
        '&' +
        this.assignees
          .map(item => {
            return 'assignee_in=' + item.id
          })
          .join('&')
      this.$emit('onFilterChanged', this.query)
    }
  }
}
</script>

<style scoped>
.spacing-playground .v-select .v-input__prepend-outer,
.spacing-playground .v-select .v-input__append-outer {
  margin-top: 0.55rem;
  margin-right: 0.2rem;
}
</style>
